// Credits: https://stackoverflow.com/a/11868159
/**
 * Gets text color (white/black) based off of BG hex.
 */
export function getTextColorFromBGHex(hexValue) {
    const rgb = hexToRgb(hexValue);
    if (!rgb) {
        throw new Error('Hex value is invalid');
    }
    // http://www.w3.org/TR/AERT#color-contrast
    const brightness = Math.round((rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000);
    return brightness > 125 ? 'black' : 'white';
}
function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
        }
        : null;
}
